import {StyleParamType, createStylesParams} from '@wix/tpa-settings'

import {Alignment} from '../../../../../../types/createStylesParams'

export type ReservationFormStylesParams = {
  reservationFormTitleAlignment: StyleParamType.Number
  reservationFormAlignment: StyleParamType.Number
  reservationFormButtonAlignment: StyleParamType.Number
}

export const reservationFormStylesParams = createStylesParams<ReservationFormStylesParams>({
  reservationFormTitleAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Left,
  },
  reservationFormAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Left,
  },
  reservationFormButtonAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Left,
  },
})
